import Service from "./Service";
import { PolicyInfoEntity, ThrowInfoEntity } from "../model/ChargePolicy";
import { PageList } from "@/model/system";
class chargePolicyService extends Service {
  getChargeList(data: any) {
    return this.post<PageList<any>>(`/ChargeInfo/List`, data);
  }
  getChargeDetails(id: string) {
    return this.get<PageList<any>>(`/ChargeInfo/Details/${id}`);
  }
  saveChargeInfo(data: any) {
    return this.post<number>(`/ChargeInfo/Save`, data);
  }
  getProductInfo(data: PolicyInfoEntity, options: any) {
    return this.post<PolicyInfoEntity[]>(`/PolicyInfo/ProductInfo`, data, options);
  }
}
export default new chargePolicyService("chargePolicy");
